export function formatQty(qty: number, unit?: string): string {
  return `${qty} ${unit ? unit : 'pcs'}`;
}
